//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'

export default {
  name: 'collectUser',
  components: {
      cmBlank
  },
  data () {
    return {
            blankShow:false,
            phone:'',
            currentPhone:'',
            list:[],
            number:0,
            selectedGoodsMap: {}, // 按手机号记录选中的商品和数量
            selectedGoods: [],
            selectedUsers: [],
            selectedPop:false,
    }
  },
  created(){
    if(this.$route.params.phone){
      this.phone = this.$route.params.phone;
      this.search();
    }
  },
  methods:{
    search(){
        if(!this.phone){
            this.$func.showToast('请输入用户手机号');
            return false;
        }
        this.saveCurrentPhoneGoods();
        let searchPhone = this.formatPhone(this.phone);
        this.phone = searchPhone;
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList(searchPhone);
    },
    getList(searchPhone){
        this.$api.getUserWaitCollectOrderList({phone:searchPhone}).then((res)=>{
          if(res){
            this.currentPhone = searchPhone;
            this.list = (res.data || []).map(item => {
                let selectedItem = this.findSelectedGoods(searchPhone, item);
                item.selectedNum = selectedItem ? selectedItem.num : Number(item.selectedNum || 0);
                return item;
            });
            this.blankShow = this.list.length == 0;
            this.refreshSelectedGoods();
          }
        })  
    },
    formatPhone(phone) {
        return String(phone || '').trim();
    },
    getGoodsKey(item) {
        return [item.order_id || '', item.gid || ''].join('_');
    },
    findSelectedGoods(phone, item) {
        let selectedGoods = this.selectedGoodsMap[this.formatPhone(phone)] || [];
        let goodsKey = this.getGoodsKey(item);
        return selectedGoods.find(val => this.getGoodsKey(val) === goodsKey);
    },
    // 点击商品增加下单数量
    addQuantity(item) {
        let selectedNum = Number(item.selectedNum || 0);
        if(this.number >= 6){
            this.$func.showToast('最多添加6件');
            return false;
        }
        if (selectedNum < Number(item.num)) {
            item.selectedNum = selectedNum + 1;
            this.updateSelectedGoods();
        } else {
            this.$func.showToast('已达到数量上限');
        }
    },
    // 减少下单数量
    minusQuantity(item) {
        let selectedNum = Number(item.selectedNum || 0);
        if (selectedNum > 0) {
            item.selectedNum = selectedNum - 1;
            this.updateSelectedGoods();
        }
    },
    changeQuantity(item) {
        let selectedNum = Number(item.selectedNum || 0);
        selectedNum = selectedNum < 0 ? 0 : selectedNum;
        selectedNum = selectedNum > Number(item.num) ? Number(item.num) : selectedNum;
        let selectedItem = this.findSelectedGoods(this.currentPhone, item);
        let otherNum = this.number - Number(selectedItem ? selectedItem.num : 0);
        let maxNum = 6 - otherNum;
        if(selectedNum > maxNum){
            selectedNum = maxNum > 0 ? maxNum : 0;
            this.$func.showToast('最多添加6件');
        }
        item.selectedNum = selectedNum;
        this.updateSelectedGoods();
    },
    // 记录选中的商品和数量
    updateSelectedGoods() {
        this.saveCurrentPhoneGoods();
        this.refreshSelectedGoods();
    },
    saveCurrentPhoneGoods() {
        let phone = this.formatPhone(this.currentPhone || this.phone);
        if(!phone){
            return false;
        }
        let selectedGoods = this.list.filter(item => Number(item.selectedNum) > 0).map(item => {
            return {
                gid: item.gid,
                num: Number(item.selectedNum),
                title: item.title,
                order_id:item.order_id
            };
        });
        if(selectedGoods.length > 0){
            this.$set(this.selectedGoodsMap, phone, selectedGoods);
        }else if(this.selectedGoodsMap[phone]){
            this.$delete(this.selectedGoodsMap, phone);
        }
    },
    refreshSelectedGoods() {
        let selectedGoods = [];
        let selectedUsers = [];
        Object.keys(this.selectedGoodsMap).forEach(phone => {
            let goods = this.selectedGoodsMap[phone] || [];
            let num = goods.reduce((acc, cur) => acc + Number(cur.num), 0);
            if(num > 0){
                selectedUsers.push({phone: phone, num: num});
                goods.forEach(item => {
                    selectedGoods.push(Object.assign({phone: phone}, item));
                });
            }
        });
        this.selectedUsers = selectedUsers;
        this.selectedGoods = selectedGoods;
        this.number = this.selectedGoods.reduce((acc, cur) => acc + Number(cur.num), 0);
        console.log('当前选中的商品及数量：', this.selectedGoods);
    },
    removeSelectedPhone(phone) {
        this.$delete(this.selectedGoodsMap, phone);
        if(phone === this.currentPhone){
            this.list.forEach(item => {
                item.selectedNum = 0;
            });
        }
        this.refreshSelectedGoods();
    },
    clearSelectedGoods() {
        this.$func.confirm('确认清空已选商品吗？','提示',()=>{
            this.selectedGoodsMap = {};
            this.selectedGoods = [];
            this.selectedUsers = [];
            this.number = 0;
            this.list.forEach(item => {
                item.selectedNum = 0;
            });
            this.closeSelectedPop();
        });
    },
    openSelectedPop() {
        this.saveCurrentPhoneGoods();
        this.refreshSelectedGoods();
        this.selectedPop = true;
    },
    closeSelectedPop() {
        this.selectedPop = false;
    },
    // 提交订单
    submitOrder(){
        this.saveCurrentPhoneGoods();
        this.refreshSelectedGoods();
        if(this.selectedGoods.length == 0){
            this.$func.showToast('请选择商品');
            return false;
        }
        let collectOrders = this.selectedUsers.map(item => {
            return {
                phone: item.phone,
                orderGoods: this.selectedGoodsMap[item.phone]
            };
        });
        this.$router.push({name:'createCollectWashOrder',params:{phone:this.phone,orderGoods:JSON.stringify(this.selectedGoods)},query:{collectOrders:JSON.stringify(collectOrders)}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/collectUser.vue